import styles from '@ui/components/TestimonialCard/TestimonialCard.module.scss';
import Card from '@ui/components/Card/Card';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import Link from '@ui/components/Link/Link';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import CardBody from '@ui/components/Card/components/CardBody/CardBody';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TestimonialCard = ({
  image,
  zitatText,
  name,
  position,
  links,
  className = null,
}) => {
  return (
    <Card className={classNames(className, styles.container)}>
      {image && <CardImage height={285} image={image} />}
      <CardBody>
        <div className={styles.quote}>
          <FontAwesomeProIcon
            icon="quote-right"
            role="presentation"
            type="solid"
          />
        </div>
        <Heading as="p" className={styles.zitatText} size="h6">
          {zitatText}
        </Heading>
        <Heading as="p" className={styles.name} noSpacing size="h6">
          {name}
        </Heading>
        <Content noSpacing size="regular">
          {position}
        </Content>
        {links?.length !== 0 && (
          <div className={styles.socialMediaWrapper}>
            {links?.map(item => (
              <div key={item?.icon}>
                <Link
                  rel="nofollow noopener"
                  target={item?.url?.target}
                  to={item?.url?.url}
                >
                  <FontAwesomeProIcon
                    className={styles.socialMenuIcon}
                    icon={item?.icon}
                    role="presentation"
                    type="brand"
                  />
                </Link>
              </div>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

TestimonialCard.propTypes = {
  className: PropTypes.string,
  image: PropTypes.shape({
    title: PropTypes.string,
    src: PropTypes.string,
    srcSet: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      url: PropTypes.shape({
        target: PropTypes.string,
        url: PropTypes.string,
        title: PropTypes.string,
      }),
    }),
  ),
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  zitatText: PropTypes.string.isRequired,
};

export default TestimonialCard;
